import { hasAtLeastOrganizationRole } from "@common/helpers/permissions/lib";
import { OrganizationUserRole } from "@common/userOrganizationRoles";
import {
    ALL_WORK_VIEW_ID,
    ASSIGNED_TO_ME_WORK_VIEW_ID,
    MONTH_END_CLOSE_VIEW_ID,
} from "./workViewIds";

interface ResolveWorkLandingParams {
    /** The user, organization, or their feature flags haven't loaded yet. */
    isLoading: boolean;
    role: OrganizationUserRole | null;
    hasCachedView: boolean;
    hasCachedBaseViewId: boolean;
}

export interface WorkLanding {
    /** The built-in view a first visit opens on; undefined keeps the cached view. */
    landingViewId: string | undefined;
    /** The view the picker marks as selected on open; undefined keeps the cached pick. */
    initialBaseViewId: string | undefined;
}

const NO_LANDING: WorkLanding = {
    landingViewId: undefined,
    initialBaseViewId: undefined,
};

/**
 * Where the Work page opens, or null while the user, organization, and their
 * flags load. A first visit lands on
 * Assigned to me below organization Manager and on Month-end close otherwise,
 * including an unknown role. A cached view stays; one cached before the Kick
 * views had no picked id and came from All work.
 */
export function resolveWorkLanding({
    isLoading,
    role,
    hasCachedView,
    hasCachedBaseViewId,
}: ResolveWorkLandingParams): WorkLanding | null {
    if (isLoading) {
        return null;
    }
    if (hasCachedBaseViewId) {
        return NO_LANDING;
    }
    if (hasCachedView) {
        return {
            landingViewId: undefined,
            initialBaseViewId: ALL_WORK_VIEW_ID,
        };
    }
    const isBelowManager =
        role !== null &&
        !hasAtLeastOrganizationRole(role, OrganizationUserRole.MANAGER);
    const landingViewId = isBelowManager
        ? ASSIGNED_TO_ME_WORK_VIEW_ID
        : MONTH_END_CLOSE_VIEW_ID;
    return { landingViewId, initialBaseViewId: landingViewId };
}
